/* eslint-disable */
import type { SpeedTestEmitterI } from '../types';
import { SpeedTestEmitterKey } from '../enums';

export class SpeedTestEmitter implements SpeedTestEmitterI {
	private listeners: Partial<Record<SpeedTestEmitterKey, Function>> = {};

	on(event: SpeedTestEmitterKey, listener: Function): void {
		this.listeners[event] = listener;
	}

	off(event: SpeedTestEmitterKey): void {
		delete this.listeners[event];
	}

	offAllEvents(): void {
		this.listeners = {};
	}

	emit(event: SpeedTestEmitterKey, ...args: any[]): void {
		if (this.listeners[event]) {
			this.listeners[event](...args);
		}
	}
}
